import { fromJS } from 'immutable';

import { ApiDashboard,UserToken } from '../../../helper/HelperAuth'
import {GetHomePushSummary, GetSenderAll} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'


export default (body, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiDashboard + 'push-summary';

    var query = body



    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'template-type':type,

},
        body : JSON.stringify(query)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    var formVal = data 
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('push-summary')
        formVal = data
        formVal = formVal
        .set('total-sent', parseInt(data.get('total-sent')) + parseInt(data.get('total-no-dr')))
        .set('total-failed',parseInt(data.get('total-failed')) + parseInt(data.get('total-not-sent')))
        .delete('total-no-dr')
        .delete('total-not-sent')
        data = formVal
    }
    dispatch({ type: GetHomePushSummary, data: fromJS(data) });
};